import React, { useState } from "react";
import "./SupportHandbookPage.css";

import SupportHandbookAccessForm from "../../components/SupportHandbookPage/SupportHandbookAccessForm/SupportHandbookAccessForm";
import HandbookHeroSection from "../../components/SupportHandbookPage/HandbookHeroSection/HandbookHeroSection";
import SupportPhilosophySection from "../../components/SupportHandbookPage/SupportPhilosophySection/SupportPhilosophySection";
import CommonScenariosSection from "../../components/SupportHandbookPage/CommonScenariosSection/CommonScenariosSection";
import HandbookStepsSlasSection from "../../components/SupportHandbookPage/HandbookStepsSlasSection/HandbookStepsSlasSection";
import EscalationTableSection from "../../components/SupportHandbookPage/EscalationTableSection/EscalationTableSection";
import DataPrivacyReminderSection from "../../components/SupportHandbookPage/DataPrivacyReminderSection/DataPrivacyReminderSection";
import HandbookContactCtaSection from "../../components/SupportHandbookPage/HandbookContactCtaSection/HandbookContactCtaSection";

export default function SupportHandbookPage() {
  const [code, setCode] = useState("");
  const [isAuthorized, setIsAuthorized] = useState(false);
  const [error, setError] = useState("");

  function handleChange(e) {
    setCode(e.target.value);
  }

  function handleSubmit(e) {
    e.preventDefault();
    if (code.trim() === "VanijyamAdmin") {
      setIsAuthorized(true);
      setError("");
      setCode("");
    } else {
      setError("Invalid code. Please try again.");
    }
  }

  if (!isAuthorized) {
    return (
      <div className="support-handbook-page-wrapper">
        <SupportHandbookAccessForm
          code={code}
          handleChange={handleChange}
          handleSubmit={handleSubmit}
          error={error}
        />
      </div>
    );
  }

  return (
    <div className="support-handbook-page-wrapper content-active">
      <HandbookHeroSection />
      <SupportPhilosophySection />
      <CommonScenariosSection />
      <HandbookStepsSlasSection />
      <EscalationTableSection />
      <DataPrivacyReminderSection />
      <HandbookContactCtaSection />
    </div>
  );
}
